/**
 * Add your action types here.
 * @module constants/ActionTypes
 * @example
 * export const UPDATE_CONTENT = 'UPDATE_CONTENT';
 */
export const GET_PERSONFUNCTIONS = 'GET_PERSONFUNCTIONS';
export const SET_PERSONFUNCTION = 'SET_PERSONFUNCTION';

export const LOAD_TAXONOMY = 'LOAD_TAXONOMY';

export const CREATE_SPONSOR = 'CREATE_SPONSOR';
export const DELETE_SPONSOR = 'DELETE_SPONSOR';
export const GET_SPONSOR = 'GET_SPONSOR';
export const LIST_SPONSORS = 'LIST_SPONSORS';
export const UPDATE_SPONSOR = 'UPDATE_SPONSOR';
